export default __webpack_public_path__ + "static/video-thumb-a764a6af4eec4e916d54c5993fea3577.png";